module.exports = __webpack_public_path__ + "static/media/my-locations.5ea00569.png";